"use strict";
/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 *   IMPORTANT: This file is used by the internal build
 *   script `extract-intl`, and must use CommonJS module syntax
 *   You CANNOT use import/export in this file.
 */
var addLocaleData = require('react-intl').addLocaleData; //eslint-disable-line
var enLocaleData = require('react-intl/locale-data/en'); //eslint-disable-line
var svLocaleData = require('react-intl/locale-data/sv'); //eslint-disable-line
var enTranslationMessages = require('./translations/en.json'); //eslint-disable-line
var svTranslationMessages = require('./translations/sv.json'); //eslint-disable-line
addLocaleData(enLocaleData);
addLocaleData(svLocaleData);
var DEFAULT_LOCALE = 'en';
// prettier-ignore
var appLocales = [
    'en',
    'sv',
];
var formatTranslationMessages = function (locale, messages) {
    var defaultFormattedMessages = locale !== DEFAULT_LOCALE
        ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages)
        : {};
    var flattenFormattedMessages = function (formattedMessages, key) {
        var _a;
        var formattedMessage = !messages[key] && locale !== DEFAULT_LOCALE
            ? defaultFormattedMessages[key]
            : messages[key];
        return Object.assign(formattedMessages, (_a = {}, _a[key] = formattedMessage, _a));
    };
    return Object.keys(messages).reduce(flattenFormattedMessages, {});
};
var translationMessages = {
    en: formatTranslationMessages('en', enTranslationMessages),
    sv: formatTranslationMessages('sv', svTranslationMessages),
};
exports.appLocales = appLocales;
exports.formatTranslationMessages = formatTranslationMessages;
exports.translationMessages = translationMessages;
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
